import { useEffect, useState } from "react";
import TopHeroMarquee from "./HeroCourseSlider";
import PerformanceSection from "./PerformanceSection";
import ReportSection from "./ReportSection";

import WalletCards from "./WalletCard";
import WelcomeCard from "./WelcomeCard";
import axios from "../../../../axios";
import UpcomingContests from "./UpcomingContest";
import RechargeOfferCard from "./RechargeOfferCard";
import CourseProgressCard from "./CourseProgressCard";


const StartQuizepage2 = () => {
  const [data, setData] = useState([]);
  const hasPurchased = false; // API se aayega
  useEffect(() => {
    axios.get("getAllCourses").then((response) => {
      if (response?.data) {
        setData(response?.data?.result);
        localStorage.setItem("plans", JSON.stringify(response?.data?.result));
      }
    });
  }, []);

  return (
    <div className="bg-bgBlue/10 mt-4 overflow-hidden sm:pb-2">
      <div className="w-full lg:pt-10">

        {!hasPurchased && <TopHeroMarquee data={data} />}

        {hasPurchased && (
          <div className="sm:h-48">
            <WelcomeCard hasPurchased={hasPurchased} />
           
          </div>
        )}
        
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-2 my-2">
          {!hasPurchased && (
          <div className="sm:h-44">
            <WelcomeCard hasPurchased={hasPurchased} />
           
          </div>
          )}
          {hasPurchased && (
            <div className="flex w-full gap-4 h-44">
              <WalletCards hasPurchased={hasPurchased} />
              <RechargeOfferCard />
            </div>
                  )}
          <div className="lg:grid-cols-4 ">
            <UpcomingContests />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-2">
          <ReportSection />
          <PerformanceSection />
        </div>

      </div>
    </div>
  );
}

export default StartQuizepage2;
